/* Volt theme JS — vanilla, no dependencies */
(function () {
  'use strict';

  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  /* ---------- Mobile menu ---------- */
  const menuBtn = $('[data-menu-toggle]');
  const mobileMenu = $('[data-mobile-menu]');
  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', () => {
      const open = !mobileMenu.hidden;
      mobileMenu.hidden = open;
      menuBtn.setAttribute('aria-expanded', String(!open));
    });
  }

  /* ---------- Cart drawer ---------- */
  const drawer = $('[data-cart-drawer]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const closeBtn = $('[data-drawer-close]', drawer);
    if (closeBtn) closeBtn.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  if (drawer) {
    $$('[data-drawer-close]', drawer).forEach(el => el.addEventListener('click', closeDrawer));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });
  }
  document.addEventListener('click', e => {
    const trigger = e.target.closest('[data-cart-open]');
    if (trigger && drawer) {
      e.preventDefault();
      refreshCart().then(openDrawer);
    }
  });

  /* ---------- AJAX cart helpers ---------- */
  const money = (cents) => {
    const fmt = window.VoltMoneyFormat || '{{amount}}';
    const amount = (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  };

  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return res.json();
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function renderShippingBar(cart) {
    const bar = $('[data-shipping-bar]');
    if (!bar) return;
    const threshold = parseFloat(bar.dataset.threshold || '0') * 100;
    if (!threshold) { bar.hidden = true; return; }
    bar.hidden = false;
    const remaining = Math.max(0, threshold - cart.total_price);
    const pct = Math.min(100, (cart.total_price / threshold) * 100);
    const fill = $('.shipping-bar__fill', bar);
    const label = $('[data-shipping-label]', bar);
    if (fill) fill.style.width = pct + '%';
    if (label) {
      label.textContent = remaining > 0
        ? bar.dataset.msgRemaining.replace('[amount]', money(remaining))
        : bar.dataset.msgDone;
    }
  }

  function renderDrawerItems(cart) {
    const body = $('[data-drawer-items]');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<p style="padding:3rem 0;text-align:center;color:var(--color-muted)">' + (body.dataset.emptyText || 'Sepetiniz boş.') + '</p>';
    } else {
      body.innerHTML = cart.items.map(item => `
        <div class="cart-row" data-line-key="${item.key}">
          <img src="${item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/, '_160x$1$2') : ''}" alt="" width="88" height="88" loading="lazy">
          <div>
            <a class="cart-row__title" href="${item.url}">${item.product_title}</a>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-row__meta">${item.variant_title}</div>` : ''}
            <div class="cart-row__meta">${item.quantity} × ${money(item.final_price)}</div>
            <button class="cart-remove" type="button" data-remove-key="${item.key}">${body.dataset.removeText || 'Kaldır'}</button>
          </div>
          <strong class="price">${money(item.final_line_price)}</strong>
        </div>`).join('');
    }
    const totalEl = $('[data-drawer-total]');
    if (totalEl) totalEl.textContent = money(cart.total_price);
    updateCartCount(cart.item_count);
    renderShippingBar(cart);
  }

  async function refreshCart() {
    const cart = await fetchCart();
    renderDrawerItems(cart);
    return cart;
  }

  document.addEventListener('click', async e => {
    const removeBtn = e.target.closest('[data-remove-key]');
    if (removeBtn) {
      removeBtn.disabled = true;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: removeBtn.dataset.removeKey, quantity: 0 })
      });
      refreshCart();
    }
  });

  /* ---------- Add to cart (product forms + quick add) ---------- */
  document.addEventListener('submit', async e => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = btn.dataset.addingText || '...'; }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      });
      if (!res.ok) {
        const err = await res.json();
        alert(err.description || err.message || 'Hata');
        return;
      }
      await refreshCart();
      if (drawer) openDrawer();
      else window.location.href = '/cart';
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = original; }
    }
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', e => {
    const step = e.target.closest('[data-qty-step]');
    if (!step) return;
    const input = step.parentElement.querySelector('input');
    const delta = parseInt(step.dataset.qtyStep, 10);
    const next = Math.max(parseInt(input.min || '1', 10), (parseInt(input.value, 10) || 1) + delta);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart page quantity change ---------- */
  document.addEventListener('change', async e => {
    const input = e.target.closest('[data-cart-line-qty]');
    if (!input) return;
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: input.dataset.cartLineQty, quantity: parseInt(input.value, 10) })
    });
    window.location.reload();
  });

  /* ---------- Product page: variant + gallery ---------- */
  const productForm = $('[data-product-form]');
  if (productForm) {
    const jsonEl = $('[data-product-json]');
    const product = jsonEl ? JSON.parse(jsonEl.textContent) : null;

    function selectedOptions() {
      return $$('.option', productForm.closest('.product__info') || document).map(opt => {
        const checked = opt.querySelector('input:checked');
        const select = opt.querySelector('select');
        return checked ? checked.value : (select ? select.value : null);
      }).filter(Boolean);
    }

    function onVariantChange() {
      if (!product) return;
      const opts = selectedOptions();
      const variant = product.variants.find(v => v.options.every((o, i) => o === opts[i]));
      const idInput = productForm.querySelector('input[name="id"]');
      const btn = productForm.querySelector('[type="submit"]');
      const priceEl = $('[data-product-price]');
      if (variant) {
        idInput.value = variant.id;
        if (priceEl) {
          priceEl.innerHTML = variant.compare_at_price > variant.price
            ? `<span class="price--sale"><span class="price__current">${money(variant.price)}</span><span class="price__regular">${money(variant.compare_at_price)}</span></span>`
            : money(variant.price);
        }
        if (btn) {
          btn.disabled = !variant.available;
          btn.textContent = variant.available ? (btn.dataset.addText || 'Sepete ekle') : (btn.dataset.soldoutText || 'Tükendi');
        }
        if (variant.featured_media) switchImage(variant.featured_media.id);
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      } else if (btn) {
        btn.disabled = true;
        btn.textContent = btn.dataset.unavailableText || 'Mevcut değil';
      }
    }
    document.addEventListener('change', e => {
      if (e.target.closest('[data-option-input]')) onVariantChange();
    });

    function switchImage(mediaId) {
      const main = $('[data-gallery-main] img');
      const thumb = $(`[data-media-id="${mediaId}"]`);
      if (main && thumb) {
        main.src = thumb.dataset.src;
        main.srcset = thumb.dataset.srcset || '';
        $$('[data-media-id]').forEach(t => t.setAttribute('aria-current', 'false'));
        thumb.setAttribute('aria-current', 'true');
      }
    }
    document.addEventListener('click', e => {
      const t = e.target.closest('[data-media-id]');
      if (t) switchImage(t.dataset.mediaId);
    });
  }

  /* ---------- Init ---------- */
  fetchCart().then(cart => { updateCartCount(cart.item_count); renderShippingBar(cart); }).catch(() => {});
})();
